import React, { useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './Resources/Table.css';
import './App.css';

export default function Customerloanlodger()
{
    const [ldetail,setLdetail]= useState([]);
    
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const navigate = useNavigate();
    
 
function loandetail()
{
    fetch(API_URL+"api/Loan/GetAllLoan?cid=" + document.getElementById("cid").value)
    .then(response => response.json())
    .then(data => {setLdetail(data)})
}


console.log(ldetail);


    return(
        <>
        <div style={{ height: "100%", width: "100%" }}>
        
        <div className="reportheader"> 
            Ledger Report
            <Navbar/>
        </div>
        
        <fieldset>
        <label for="cid">Customer ID</label>
        <input id="cid" style={{ height: "30px", width: "40%", marginLeft: "10px" }}></input>
        <button type="button" className="fetchbutton"
                                        onClick={() => {if(document.getElementById("cid").value !== '')loandetail()}}>Search</button>
        </fieldset>
        <table className="gfg" style ={{width:"100%", marginBottom:"40px"}}>
            <tr>
                <th>L.No</th>
                <th>Amount</th>
                <th>L.Date</th>
                <th>C.Date</th>
                <th>Status</th>
                
            </tr>
        {ldetail.map(loan => {return(<tr style={{marginTop:"10px"}}>
                                    <td>{loan.AccountNo}</td>
                                    <td>{loan.LoanAmount}</td>
                                    <td>{loan.LoanDate.slice(8,10)}-{loan.LoanDate.slice(5,7)}-{loan.LoanDate.slice(0,4)}</td> 
                                    <td>{loan.DateOfLoanClosing.slice(8,10)}-{loan.DateOfLoanClosing.slice(5,7)}-{loan.DateOfLoanClosing.slice(0,4)}</td>
                                    <td style ={{backgroundColor:"red", color:"white"}} onClick={()=>{navigate('/ledgerview',{state:{ldetail, loanNo:loan.LoanNo,guarantorid:loan.GuarantorID}})}}> {loan.LoanStatus === 0 ? "Closed":"Open"}</td>
                                    </tr>)})}
                                
        </table>
        <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}}>Back</button>
        </div>
        </>
    )
}